import React, { useState,useEffect } from 'react';

import { useFetchEntity } from '../../Services/fetchApi';
import Select from './Selector';
import { useAuth } from '../../Services/AuthContext';
import { endpoints, RoleNames } from '../../utils/Constants';
import { FormLabel } from '../Form/FormLabel';
import ClientDepartment from '../Cards/ClientDepartment'
import { FormGroup} from 'reactstrap'
import { useFormikContext, getIn } from 'formik';


const DepartmentSelector = ({noEdit, route, value, id, clientIdName, label }) => {
    const [user,] = useAuth();

    const getSelector = (depatments) => {
        return depatments?depatments.map(department => { return { label: department.departmentName + ' | ' + department.firstName + ' | ' + department.lastName + ' | ' + department.email, value: department.id } }):[];
    }
   
    const { values, setFieldValue } = useFormikContext();
    const clientMasterId = getIn(values, clientIdName);
    const [departments, loading, error] = useFetchEntity({ name: 'Client', getByStatus: () => !noEdit && user.role === RoleNames.Admin ? endpoints.getClientDepartmentsForClientByStatus + clientMasterId + '/Active':null });
    const [departmentSelect, setDepartmentSelect] = useState(departments?getSelector(departments)  : []);
    const [department, setDepartments] = useState();
    const [selectValue, setSelectValue] = useState();
    const formikValue = values ? getIn(values, id):value;
    useEffect(() => {
        if (departments) {
            const select = getSelector(departments);
            setDepartmentSelect(select)
            const c = departments?.find(xx => { return xx.id === formikValue });
            setDepartments(c);
            const v = select.find(xx => { return xx.value === formikValue });
            setSelectValue(v);
        }
    }, [departments, formikValue]);
    useEffect(() => {
        if (formikValue && departmentSelect && departmentSelect.length) {
            const v = departmentSelect.find(x => x.value === formikValue);
            setSelectValue(v);
            const c = departments?.find(xx => { return xx.id === formikValue });
            setDepartments(c);
        }
    }, [formikValue, departmentSelect,departments])
 
    const onSelectChange = (newValue) => {
        setFieldValue(id,newValue.value);
        const c = departments.find(xx => { return xx.id === newValue.value });
        setDepartments(c);
        const v = departmentSelect?.find(xx => { return xx.value === newValue.value });
        setSelectValue(v);
    }

    return !noEdit && user.role === RoleNames.Admin ?<FormGroup><FormLabel>{label}</FormLabel>
       
        {!noEdit && user.role === RoleNames.Admin ? departmentSelect ? <Select id="clientId" options={departmentSelect} onChange={onSelectChange} value={selectValue} /> :null:null}
        {!noEdit && user.role === RoleNames.Admin && department ? <ClientDepartment route={route} clientDepartment={department} /> : null}
        {loading? <p>loading</p>:''}
        {error ? <p>error</p> : ''}
    </FormGroup>:null

}

export default DepartmentSelector; 